// 格式化seconds为mm:ss
export const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

// 格式化seconds为hh:mm:ss
export const formatTimeExtended = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

// 格式化数字，到没有小数点位置
export const formatNumber = (number: number) => {
    return Math.floor(number);
}

// 一个时间字符串，只取分秒部分,例如 12:30
export const formatTimeShort = (timeString: string) => {
    // 将输入的字符串解析为Date对象
    const dateTime = new Date(timeString);

    // 提取小时、分钟和秒数
    let hours: string | number = dateTime.getHours();
    let minutes: string | number = dateTime.getMinutes();

    // 格式化输出，保证两位数显示（不足时补0）
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    // 返回格式化后的时间字符串
    return `${hours}:${minutes}`;
}
